import { render, staticRenderFns } from "./MiddleWrite.vue?vue&type=template&id=10b63fb5&scoped=true&"
import script from "./MiddleWrite.vue?vue&type=script&lang=js&"
export * from "./MiddleWrite.vue?vue&type=script&lang=js&"
import style0 from "./MiddleWrite.vue?vue&type=style&index=0&id=10b63fb5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b63fb5",
  null
  
)

export default component.exports